import styled from 'styled-components';
import { formChevronDown } from "../../styles";
import IconChevronDown from "../Icon/IconChevronDown";
export default styled(IconChevronDown).attrs({
  iconSize: 16,
  'aria-hidden': 'true'
}).withConfig({
  displayName: "SelectArrow",
  componentId: "sc-1g9hsv1-0"
})(["", ";"], formChevronDown());